import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import AccountSettingsSection from "users/settings/_views/account-settings-section";
import DashboardSettingsSection from "users/settings/_views/dashboard-settings-section";
import NotificationSettingsSection from "users/settings/_views/notification-settings-section";
import PasswordSettingsSection from "users/settings/_views/password-settings-section";
import TableSettingsSection from "users/settings/_views/table-settings-section";
import TutorialSettingsSection from "users/settings/_views/tutorial-settings-section";

/**
 * Where a person manages their own account and preferences, opened from the account menu.
 *
 * Before this, each preference was kept where it applied — the dashboard's cards menu, the Help
 * page, the knowledge base panel — and the menu's "Settings" item said only that it was not built.
 * The places that had them keep them; this page gathers them so a person need not know each one.
 */
export default function SettingsPage() {
  return (
    <Box sx={{ height: "100%", overflow: "auto", p: { xs: 2, sm: 4 } }}>
      <Stack spacing={3} sx={{ maxWidth: 760, mx: "auto" }}>
        <div>
          <Typography component="h1" variant="h4">Settings</Typography>
          <Typography color="text.secondary">
            Your account, your password, your notifications, and how Attorney Hub looks and helps you.
          </Typography>
        </div>
        <AccountSettingsSection />
        <PasswordSettingsSection />
        <DashboardSettingsSection />
        <TableSettingsSection />
        <TutorialSettingsSection />
        <NotificationSettingsSection />
      </Stack>
    </Box>
  );
}
